import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import CenterPanelUpdate from './centerPanel';
import RightPanelUpdate from './rightPanel';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
import { updateOrganisationalUnitLogoImage } from '../../../../actions/organisation.js';

export default function LogoPauseImage(props) {
  const dispatch = useDispatch();
  const [logoPictureControlState, setLogoPictureControlState] = useState();

  const saveLogoPauseImage = () => {
    const logoImg = logoPictureControlState.getBase64();
    dispatch(
      updateOrganisationalUnitLogoImage(
        props.organisation.networkId,
        logoImg,
        logoImg == '' ? false : true,
        props.organisation.name
      )
    );
  };
  const setLogoPictureControl = (imgCtrl) => {
    setLogoPictureControlState(imgCtrl);
  };

  const rightPanel = (
    <RightPanelUpdate
      organisation={props.organisation}
      saveLogoPauseImage={saveLogoPauseImage}
      organisationalUnitLogoImageForm={props.organisationalUnitLogoImageForm}
      readOnly={props.readOnly}
    />
  );
  const centerPanel = (
    <CenterPanelUpdate
      imageLogoRef={setLogoPictureControl}
      // imagePauseRef={setPausePictureControl}
      organisationalUnitLogoImageForm={props.organisationalUnitLogoImageForm}
      organisation={props.organisation}
      readOnly={props.readOnly}
    />
  );
  const showModal = props.showOrganisationalUnitLogoImageModal;

  return (
    <Modal show={showModal} hideWhenClickAway={false} className={'waiting-area-logo-pause-image'}>
      <PopupHeader
        helpLink={APP.EXTERNAL_LINKS.OrgUnit.HelpOrgUnitLogo}
        title={APP.LANGUAGE.DefaultOrgLogo.Title}
        subtitle={props.organisation ? props.organisation.name : ''}
      />
      <div className="content">
        <div className="main-ui-container waiting-area-update">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">{rightPanel}</div>
            </div>
            {centerPanel}
            <div className="bottom-rail-with-left-and-right-content mrtl">{rightPanel}</div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
